import policy from './categorySeoPolicy.js';
export const { categorySeoIndexable } = policy;
